import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestUpdates() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            最新更新
          </h2>
          <Link
            to="/category/juji"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestUpdates.map((video) => (
            <Link
              key={video.slug}
              to={`/article/${video.slug}`}
              className="group flex gap-4 bg-background-100 rounded-xl p-3 md:p-4 cursor-pointer transition-all hover:-translate-y-0.5"
            >
              <div className="relative w-36 md:w-40 shrink-0 aspect-video rounded-lg overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors"></div>
              </div>
              <div className="flex flex-col justify-between min-w-0 flex-1">
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 line-clamp-2">
                    {video.title}
                  </h3>
                  <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                    <span>{video.category}</span>
                    <span className="text-foreground-300">|</span>
                    <div className="flex items-center gap-0.5">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-xs"></i>
                      </div>
                      {video.rating}
                    </div>
                  </div>
                </div>
                <div>
                  <span className="inline-block px-2 py-0.5 rounded-md text-xs font-medium bg-accent-100 text-accent-700 mb-1">
                    {video.updateLabel}
                  </span>
                  <span className="block text-xs text-foreground-400">{video.updateTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}